import {
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    TextField
} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import React, {useContext, useRef, useState} from "react";
import {useAsyncAction} from "nate-react-api-helpers";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {api} from "../../../../api/API";
import {useProjectId} from "../../shopdrawing/ProjectName";
import {useAlternative} from "../alternative/Alternative";
import {EditContext} from "../../../../misc/scroller/EditProvider";

export function NewRowMenu() {
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState("10")
    const projectId = useRef(useProjectId());
    const alt = useAlternative();
    const ctx = useContext(EditContext);
    const ctxRef = useRef(ctx);
    ctxRef.current = ctx;

    const add = useAsyncAction(async (qty: number) => {
        try {
            if (!alt) {
                await api.openings.bulkUpsert(
                    Array.from({length: qty}, () => ({
                        project: projectId.current,
                    }))
                )
            } else {
                await api.quoteOpenings.upsertBulk(
                    Array.from({length: qty}, () => ({
                        name: "",
                        project: projectId.current,
                        quoteAlternative: alt,
                    }))
                )
            }

            setOpen(false);
        } finally {
            ctxRef.current.reload();
        }
    }, []);

    return (
        <>
            <IconButton color="primary" onClick={(e) => setOpen(true)}>
                <MoreVertIcon />
            </IconButton>
            {open && <Dialog2 open onClose={() => setOpen(false)} onEnterPress={() => add.callback(parseInt(value))}>
                <DialogTitle>
                    Add Multiple Rows
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <div style={{height: 8}} />
                        <TextField label="Qty" value={value} onChange={e => setValue(e.target.value)} />
                    </DialogContentText>
                </DialogContent>
                <SmoothActionBar
                    loading={add.loading}
                    error={add.error}
                    actionName="Add"
                    onCancel={() => setOpen(false)}
                    onSubmit={() => add.callback(parseInt(value))}
                />
            </Dialog2>}
        </>
    )
}